import { BackendModel, BackendService } from '../core/backend.service';
import { Email } from '../security/user/email.model';
export class SubclienteMonto extends BackendModel {

    public static path = '/subclientes/';

    id: number;
    username: string;
    idAcuerdo: number;
    idMontoMax: number;
    montoMax: number;
    consumido: number;

    constructor(protected backendService: BackendService, model?: SubclienteMonto) {
        super(backendService, model);
      }
}


// WEBPACK FOOTER //
// ./src/app/cliente/subclienteMonto.model.ts